
import Panzoom from '@panzoom/panzoom';
import fetchData from 'Models/fetch-data';
import store from 'Store';
import { lockPage, unlockPage } from 'Models/locker';
import { dim, undim } from 'Models/dimmer';
import * as ProjectConfig from 'Models/utils/project-config';
import generateButton from 'Models/button';
import generateIcon from 'Models/icon';
import SimpleScrollbar from 'simple-scrollbar';

export default function map (element) {
    const baseMapSettings = {
        locations: false,
        locationsUrl: false,
        teaserMode: false,
        fullMapUrl: false,
        mapCenter: false,
        mapScale: false,
        groupLocations: true,
        prefilterCountry: false,
    };

    const customMapSettings = JSON.parse(element.dataset.mapSettings);

    const mapSettings = { ...baseMapSettings, ...customMapSettings };

    const elements = {
        page: document.querySelector('.page'),
        imageHolder: element.querySelector('.js-map__main'),
        zoomable: element.querySelector('.js-map__zoomable'),
        fake: element.querySelector('.js-map__fake'),
        locations: element.querySelector('.js-map__locations'),
        locationsList: element.querySelector('.js-map__location-list'),
        zoomIn: element.querySelector('.js-map__control__zoom-in'),
        zoomOut: element.querySelector('.js-map__control__zoom-out'),
        checkboxes: element.querySelectorAll('input[type="checkbox"]'),
        scrollContainers: element.querySelectorAll('.js-map__scrollcontainer'),
        filterToggle: element.querySelector('.js-map__filter-toggle'),
        checkboxContainers: element.querySelectorAll('.js-map__option'),
    };

    const isMobile = !store.getters.getActiveBreakpoints.includes('tablet-landscape');
    const showLocations = !(mapSettings.teaserMode && isMobile);
    let initialized = false;
    let countryListFilled = false;

    let zoomInstance;
    let locations;
    let locArray = [];
    let groups;
    let bu;
    let filters;

    const transitionDuration = 300;

    // image
    // const windowWidth = store.getters.getWindowWidth;
    const mapWidth = 615.3; // in pixels
    const mapHeight = 394.1; // in pixels
    let imgWidth;

    let zoomActive;
    let zoomTimer;
    let zoomInt = false;
    let zoomData;
    let zoomScale = 10;
    let zoomX;
    let zoomY;
    let zoomChanged;

    window.doubleClick = 0;

    let initialCountryPosition = false;
    let foundCountry;
    let foundItem;

    function init () {
        checkForSearchQuery();
        if (mapSettings.locationsUrl) {
            loadData();
        } else if (mapSettings.locations) {
            startMapWithLocations();
        }

        addResizeListener();
    }

    function addResizeListener () {
        store.watch(
            state => state.windowWidth,
            () => {
                elements.locations.innerHTML = '';
                handleLocations();
                mapInteractive();
                if (mapSettings.teaserMode) {
                    mapUpdate();
                }
            },
            { immediate: false },
        );
    }

    // ZOOM
    function mapInteractive () {
        const zoomOptions = {
            startScale: isMobile ? 10 : 6,
            maxScale: isMobile ? 180 : 75,
            minScale: 3,
            duration: transitionDuration,
            animate: true,
            // startY: isMobile ? 5 : 20,
            startY: isMobile ? 5 : 10,
            step: isMobile ? 7 : 0.3,
            canvas: true,
        };

        if (mapSettings.teaserMode) {
            zoomOptions.disablePan = true;
            zoomOptions.cursor = 'default';
            zoomOptions.startScale = 5;
            // zoomOptions.startY = 20; // doesn't work yet
        }
        if (mapSettings.mapScale) {
            // zoomOptions.startScale = 2;
            zoomOptions.startScale = 1;
        }

        zoomInstance = Panzoom(elements.zoomable, zoomOptions);
        zoomChanged = true;

        if (mapSettings.mapCenter) {
            initialCountryPosition = mapSettings.mapCenter;
        }

        if (!mapSettings.teaserMode) {
            elements.zoomable.parentElement.addEventListener('wheel', function (e) {
                zoomInstance.zoomWithWheel(e, { animate: false });
                element.classList.remove('is-zooming');
            });

            elements.zoomable.addEventListener('panzoomzoom', function () {
                element.classList.add('is-zooming');
            });

            elements.zoomable.addEventListener('panzoompan', function () {
                element.classList.remove('is-zooming');
            });
        }

        mapUpdate();

        setTimeout(() => {
            element.classList.add('map--initialized');
        }, 300);

        // if there is a query param with country, trigger click on checkbox and build fake location
        if (foundCountry) {
            setTimeout(() => {
                const checkbox = element.querySelector(`input[name="${foundCountry}"]`);
                checkbox.click();
                centerMapOnInitialLocation();
            }, 200);
        } else if (initialCountryPosition) {
            setTimeout(() => {
                centerMapOnInitialLocation();
                if (mapSettings.teaserMode) {
                    mapUpdate();
                }
            }, 400);
        }

        // Go to item detail
        if (foundItem && foundItem !== '') {
            setTimeout(() => {
                const listItem = element.querySelector(`.map__filters__location[data-item-id="${foundItem}"]`);
                listItem.click();
            }, 500);
        }
    }

    function centerMapOnInitialLocation () {
        const pos = convertGeoToPixel(initialCountryPosition.split(',')[0], initialCountryPosition.split(',')[1]);
        let fakeLocEl = document.createRange().createContextualFragment(`<div class="map__fake-location" style="top:${pos.y}%; left:${pos.x}%;"></div>`);
        elements.locations.appendChild(fakeLocEl);
        fakeLocEl = elements.locations.querySelector('.map__fake-location');
        elements.zoomable.classList.add('transitioning');
        zoomInstance.zoomToPoint(mapSettings.mapScale ? mapSettings.mapScale : isMobile ? 30 : 15, {
            clientX: fakeLocEl.getBoundingClientRect().left,
            clientY: fakeLocEl.getBoundingClientRect().top,
        });

        elements.zoomable.classList.add('transitioning');
        element.classList.remove('is-zooming');

        zoomScale = zoomInstance.getScale();

        element.classList.add('map--positioned');
        setTimeout(() => {
            elements.zoomable.classList.remove('transitioning');
        }, 550);
    }

    // LOAD DATA
    async function loadData () {
        if (!initialized) {
            initialized = true;

            try {
                const response = await fetchData(mapSettings.locationsUrl, 'GET');
                if (response.success) {
                    locations = response.locations;
                    bu = response.bu;
                    filters = response.filter;
                    prepareFilters();
                    handleLocations();
                    mapInteractive();
                    addListeners();
                }
            } catch (error) {
                console.error(error);
            }
        }
    }

    function prepareFilters () {
        elements.checkboxContainers.forEach(container => {
            const checkboxEl = container.querySelector('input[type="checkbox"]');
            if (checkboxEl && checkboxEl.name === '*') {
                const filterGroup = container.dataset.type;
                const filterValue = checkboxEl.name;
                if (checkboxEl.checked) filters[filterGroup].push(filterValue);
            }
        });
    }

    function startMapWithLocations () {
        locations = mapSettings.locations;
        handleLocations();
        mapInteractive();
        addListeners();
    }

    function handleLocations () {
        if (locations && showLocations) {
            let counter = 0;
            let largeLocationCounter = 0;
            locArray = [];
            locations.forEach(loc => {
                const showLoc = loc.show_in_map;

                if (showLoc) {
                    const pos = convertGeoToPixel(loc.coordinates.lat, loc.coordinates.lng);

                    // create location dot
                    let largeLocationClass = '';
                    if (loc.size === 'large') {
                        largeLocationCounter++;
                        largeLocationClass = ' map__location--large--' + largeLocationCounter;
                    }
                    const locString = ` <div class="map__location map__location--${loc.type} map__location--${loc.size}${largeLocationClass}" data-id="${counter}" data-item-id="${loc.id}" style="left: ${pos.x}%; top: ${pos.y}%;">
                        ${loc.size === 'large' && mapSettings.teaserMode ? `
                            <div class="map__location__rings">
                                <span></span><span></span><span></span>
                            </div>
                        ` : ''}
                        <div class="map__location__inner">
                            <div class="map__location__title h4">${loc.pin_title}</div>
                        </div>
                    </div>`;
                    const locEl = document.createRange().createContextualFragment(locString);

                    const locObj = {
                        l: locEl,
                        i: counter,
                        x: parseFloat(pos.x),
                        y: parseFloat(pos.y),
                        size: 1,
                        type: loc.type,
                        filter: loc.filter,
                        loc: loc,
                        visible: true,
                    };

                    elements.locations.appendChild(locEl);
                    locArray.push(locObj);

                    if (elements.locationsList && !countryListFilled) {
                        // create list item
                        const listEl = document.createElement('div');
                        listEl.classList.add('map__filters__location', `map__filters__location--${loc.type}`, 'text', 'text-small');
                        listEl.dataset.id = counter;
                        listEl.dataset.itemId = loc.id;
                        listEl.innerHTML = loc.title;
                        elements.locationsList.appendChild(listEl);
                    }

                    counter++;
                }
            });

            countryListFilled = true;

            setTimeout(function () {
                addScrollBars();
                mapGroups();
            }, 100);
        }
    }

    function convertGeoToPixel (latitude, longitude) {
        const mapLngLeft = -171.841723; // in degrees. the longitude of the left side of the map (i.e. the longitude of whatever is depicted on the left-most part of the map image)
        const mapLngRight = 189.8;
        const mapLatBottom = -55.15;

        const mapLatBottomRad = mapLatBottom * Math.PI / 180;
        const latitudeRad = latitude * Math.PI / 180;
        const mapLngDelta = (mapLngRight - mapLngLeft);

        const worldMapWidth = ((mapWidth / mapLngDelta) * 360) / (2 * Math.PI);
        const mapOffsetY = (worldMapWidth / 2 * Math.log((1 + Math.sin(mapLatBottomRad)) / (1 - Math.sin(mapLatBottomRad))));

        const x = (longitude - mapLngLeft) * (mapWidth / mapLngDelta);
        const y = mapHeight - ((worldMapWidth / 2 * Math.log((1 + Math.sin(latitudeRad)) / (1 - Math.sin(latitudeRad)))) - mapOffsetY);

        const xp = x * 100 / mapWidth;
        const yp = y * 100 / mapHeight;

        return { x: xp, y: yp };
    }

    function mapUpdate () {
        if (!mapSettings.teaserMode) {
            requestAnimationFrame(mapUpdate);
        }

        zoomData = {
            x: zoomInstance.getPan().x,
            y: zoomInstance.getPan().y,
            scale: zoomInstance.getScale(),
        };

        elements.fake.style.transform = `scale(${zoomData.scale}) translate(${zoomData.x}px, ${zoomData.y}px)`;

        if (zoomData && (zoomScale !== zoomData.scale || zoomX !== zoomData.x || zoomY !== zoomData.y || imgWidth !== elements.zoomable.getBoundingClientRect().width)) {
            if (zoomScale !== zoomData.scale) {
                if ((!zoomInt && zoomActive) || zoomScale !== zoomData.scale) {
                    if (zoomScale !== zoomData.scale) {
                        clearTimeout(zoomTimer);
                        zoomTimer = setTimeout(function () {
                            mapGroups();
                        }, 0);
                    } else {
                        zoomInt = setInterval(function () {
                            clearTimeout(zoomTimer);
                            zoomTimer = setTimeout(function () {
                                mapGroups();
                            }, 0);
                        }, transitionDuration);
                    }
                }
            }

            if (zoomX !== zoomData.x || zoomY !== zoomData.y || zoomScale !== zoomData.scale) {
                const zoomablePos = elements.fake.getBoundingClientRect();
                const imageHolderPos = elements.imageHolder.getBoundingClientRect();
                if (zoomScale !== zoomData.scale) zoomChanged = true;

                zoomScale = zoomData.scale;
                zoomX = zoomData.x;
                zoomY = zoomData.y;

                elements.locations.style.width = `${zoomScale * 100}%`;
                elements.locations.style.height = `${zoomScale * 100}%`;

                elements.locations.style.left = zoomablePos.left - imageHolderPos.left + 'px';
                elements.locations.style.top = zoomablePos.top - imageHolderPos.top + 'px';
            }
        }
    }

    // group pins
    function mapGroups () {
        const min = 30;
        if (zoomChanged && showLocations) {
            zoomChanged = false;

            elements.locations.querySelectorAll('.map__location').forEach(item => {
                item.classList.remove('invisible');
            });
            elements.locations.querySelectorAll('.map__location--group').forEach(item => {
                item.classList.remove('show');
            });

            const locationsWidth = elements.locations.getBoundingClientRect().width;
            const clonedLocations = locArray.map(a => ({ ...a }));

            groups = {};

            if (!mapSettings.groupLocations) {
                return false;
            }
            for (let i = 0; i < locations.length; i++) {
                const l = clonedLocations.shift();

                if (l === undefined) continue;

                if (l.visible === true) {
                    for (var c = 0; c < clonedLocations.length; c++) {
                        const lc = clonedLocations[c];
                        const dist = locationsWidth / 100 * distance(l, lc);

                        if (dist < min && lc.visible === true) {
                            let g = l.group || lc.group;

                            if (!g) {
                                g = l.group = lc.group = groups['g' + l.i] = { i: l.i, group: [l, lc], x_min: 101, y_min: 101, x_max: -1, y_max: -1 };

                                mapGroupPos(g, l);
                                mapGroupPos(g, lc);

                                if (!elements.locations.querySelectorAll(`.js-map__group.g${l.i}`).length) {
                                    const groupString = `<div class="map__location map__location--group g${l.i}">
                                                            <div class="map__location__inner"></div>
                                                        </div>`;
                                    const groupEl = document.createRange().createContextualFragment(groupString);
                                    elements.locations.appendChild(groupEl);
                                }
                            } else {
                                if (l.group && lc.group) {
                                    while (function () { return l.group.group.length; } > 0) {
                                        lc.group.group.push(l.group.group.shift());
                                    }
                                    delete groups['g' + l.i];
                                } else {
                                    g.group.push(l.group ? lc : l);
                                    l.group = lc.group = (l.group || lc.group);
                                    mapGroupPos(g, l.group ? lc : l);
                                }
                            }

                            const groupEl = elements.locations.querySelector(`.g${g.i}`);

                            if (groupEl) {
                                const x = g.x_min + (g.x_max - g.x_min) / 2;
                                const y = g.y_min + (g.y_max - g.y_min) / 2;

                                groupEl.innerHTML = '';
                                groupEl.classList.add('show');

                                groupEl.style.left = `${x}%`;
                                groupEl.style.top = `${y}%`;

                                const numberString = `<div class="map__location__inner">
                                                        <div class="map__location__number">${g.group.length}</div>
                                                      </div>`;
                                const numberEl = document.createRange().createContextualFragment(numberString);
                                groupEl.appendChild(numberEl);
                            }

                            elements.locations.querySelectorAll('.map__location')[l.i].classList.add('invisible');
                            elements.locations.querySelectorAll('.map__location')[lc.i].classList.add('invisible');
                        }
                    }
                }
            }
        }
    }

    function distance (l, lc) {
        const distX = lc.x - l.x;
        const distY = lc.y - l.y;
        const dist = Math.sqrt(distX * distX + distY * distY);
        return dist;
    }

    function mapGroupPos (g, l) {
        if (g.x_max < l.x) {
            g.x_max = l.x;
        }
        if (g.x_min > l.x) {
            g.x_min = l.x;
        }
        if (g.y_max < l.y) {
            g.y_max = l.y;
        }
        if (g.y_min > l.y) {
            g.y_min = l.y;
        }
    }

    function mapSearchUpdate () {
        locArray.forEach(loc => {
            const filterVals = [];
            for (const type in filters) {
                if ((loc.filter[type] && loc.filter[type].some(i => filters[type].includes(i))) || filters[type].includes('*')) {
                    filterVals.push(true);
                } else {
                    filterVals.push(false);
                }
            }

            if (filterVals.every(e => e === true)) {
                loc.visible = true;
                element.querySelector(`.map__location[data-id="${loc.i}"]`).classList.remove('unavailable');
                element.querySelector(`.map__filters__location[data-id="${loc.i}"]`).classList.remove('unavailable');
            } else {
                loc.visible = false;
                element.querySelector(`.map__location[data-id="${loc.i}"]`).classList.add('unavailable');
                element.querySelector(`.map__filters__location[data-id="${loc.i}"]`).classList.add('unavailable');
            }
        });

        setTimeout(() => {
            zoomChanged = true;
            mapGroups();
        }, 100);
    }

    // LISTENERS
    function addListeners () {
        // click on location
        element.addEventListener('click', function (e) {
            if (e.target.classList.contains('map__location')) {
                locationClickListener(e);
            }
        });

        // hover on location
        element.addEventListener('mouseover', function (e) {
            if (e.target.classList.contains('map__location')) {
                element.classList.add('map--hover');
            }
        });
        element.addEventListener('mouseout', function (e) {
            if (e.target.classList.contains('map__location')) {
                element.classList.remove('map--hover');
            }
        });

        // click on list location triggers click on dot
        element.addEventListener('click', function (e) {
            if (e.target.classList.contains('map__filters__location')) {
                const id = e.target.dataset.id;

                element.querySelector(`.map__location[data-id="${id}"]`).click();
            }
        });

        // click on overlay to close it
        document.addEventListener('click', function (e) {
            if (e.target.classList.contains('js-map__overlay__close') || e.target.classList.contains('js-map__overlay')) {
                closeOverlay();
            }
        });

        // zoom in and zoom out buttons
        if (elements.zoomIn) {
            elements.zoomIn.addEventListener('click', function () {
                element.classList.add('is-zooming');
                setTimeout(() => {
                    zoomInstance.zoomIn({ step: 0.3 });
                }, 50);
            });
        }
        if (elements.zoomOut) {
            elements.zoomOut.addEventListener('click', function () {
                element.classList.add('is-zooming');
                setTimeout(() => {
                    zoomInstance.zoomOut({ step: 0.3 });
                }, 50);
            });
        }

        // filter checkboxes
        if (elements.checkboxes) {
            elements.checkboxes.forEach(box => {
                box.addEventListener('change', function () {
                    const filterGroup = this.closest('.js-map__option').dataset.type;
                    const filterValue = this.name;
                    const isChecked = this.checked;

                    // // show all case
                    if (filterValue === '*') {
                        if (isChecked) uncheckOtherValues(filterGroup);
                    } else {
                        uncheckAllValue(filterGroup);
                    }

                    if (filters[filterGroup].includes(filterValue)) {
                        if (!isChecked) filters[filterGroup] = filters[filterGroup].filter(it => { return it !== filterValue; });
                    } else {
                        if (isChecked) filters[filterGroup].push(filterValue);
                    }

                    mapSearchUpdate();
                });
            });
        }

        // on mobile, close filters when touching map
        if (elements.filterToggle) {
            elements.imageHolder.addEventListener('touchstart', function () {
                if (elements.filterToggle.classList.contains('is-open')) {
                    elements.filterToggle.click();
                }
            });
        }
    }

    function uncheckAllValue (group) {
        const checkboxContainers = element.querySelectorAll(`.js-map__option[data-type="${group}"]`);

        checkboxContainers.forEach(container => {
            const checkboxEl = container.querySelector('input[type="checkbox"]');
            const filterValue = checkboxEl.name;
            if (filterValue === '*') {
                checkboxEl.checked = false;
                filters[group] = filters[group].filter(it => { return it !== '*'; });
            }
        });
    }

    function uncheckOtherValues (group) {
        const checkboxContainers = element.querySelectorAll(`.js-map__option[data-type="${group}"]`);

        checkboxContainers.forEach(container => {
            const checkboxEl = container.querySelector('input[type="checkbox"]');
            const filterValue = checkboxEl.name;
            if (filterValue !== '*') {
                checkboxEl.checked = false;
                filters[group] = ['*'];
            }
        });
    }

    function locationClickListener (e) {
        if (mapSettings.teaserMode) {
            const itemId = e.target.dataset.itemId;
            if (mapSettings.fullMapUrl) {
                let url = mapSettings.fullMapUrl;
                if (itemId) {
                    url += '?i=' + itemId;
                }
                window.location.href = url;
            }
            return false;
        }
        const targetPos = e.target.getBoundingClientRect();
        const pos = {
            clientX: targetPos.left,
            clientY: targetPos.top,
        };

        elements.zoomable.classList.add('transitioning');
        const isGroup = e.target.classList.contains('map__location--group');
        let zoomMultiplier = isGroup ? 4 : 1;
        if (isGroup) {
            element.classList.add('is-zooming');
            const groupCount = parseInt(e.target.querySelector('.map__location__number').innerText);
            if (groupCount > 2) {
                zoomMultiplier = zoomMultiplier / 2;
            }
        }

        setTimeout(() => {
            zoomInstance.zoomToPoint(zoomScale + (isMobile ? 20 : 10) * zoomMultiplier, pos);
        }, 50);

        zoomScale = zoomInstance.getScale();

        setTimeout(() => {
            zoomChanged = true;
            mapGroups();
        }, transitionDuration);

        setTimeout(() => {
            elements.zoomable.classList.remove('transitioning');
            element.classList.remove('is-zooming');
        }, 550);

        if (!isGroup) showOverlay(locArray[e.target.dataset.id].loc);
    }

    function checkForSearchQuery () {
        if (mapSettings.prefilterCountry) {
            foundCountry = mapSettings.prefilterCountry;
            setPrefilteredCountry(foundCountry);
        } else if (window.location.search !== '') {
            // country
            let key = 'country';
            foundCountry = decodeURIComponent(window.location.search.replace(new RegExp('^(?:.*[&\\?]' + encodeURIComponent(key).replace(/[.+*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1'));

            if (foundCountry && foundCountry !== '') {
                setPrefilteredCountry(foundCountry);
            }

            // item
            key = 'i';
            foundItem = decodeURIComponent(window.location.search.replace(new RegExp('^(?:.*[&\\?]' + encodeURIComponent(key).replace(/[.+*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1'));
        }
    }

    function setPrefilteredCountry (foundCountry) {
        const checkbox = element.querySelector(`input[name="${foundCountry}"]`);
        const checkboxParent = checkbox.closest('.js-map__option');

        initialCountryPosition = checkboxParent.dataset.mapCenter;
    }

    function addScrollBars () {
        elements.scrollContainers.forEach(scroller => {
            SimpleScrollbar.initEl(scroller);
        });
    }

    // OVERLAY
    function showOverlay (locData) {
        lockPage();
        dim();

        const overlayElement = document.createRange().createContextualFragment(createOverlayString(locData));
        elements.page.appendChild(overlayElement);
        setTimeout(() => {
            elements.page.querySelector('.js-map__overlay').classList.add('visible');
        }, 10);
    }

    function closeOverlay () {
        const overlayElement = elements.page.querySelector('.js-map__overlay');

        overlayElement.classList.remove('visible');
        setTimeout(() => {
            overlayElement.parentNode.removeChild(overlayElement);
            unlockPage();
            undim();
        }, 300);
    }

    function createOverlayString (locData) {
        return `
            <div class="map-overlay js-map__overlay">
                <div class="map-overlay__inner">
                    <div class="map-overlay__close js-map__overlay__close">${generateIcon('close', true)}</div>
                    <div class="map-overlay__left">
                        <div class="map-overlay__left__top">
                            <h3 class="map-overlay__title h5">
                                ${locData.title}
                                <div class="map-overlay__flag">
                                    <img data-srcset="${ProjectConfig.get('assetsUrl')}/images/flags/${locData.filter.country[0]}.png" class="lazyload">
                                </div>
                            </h3>
                            <div class="map-overlay__text text text-small">${locData.address}</div>
                            ${locData.filter.bu && locData.filter.bu !== undefined && locData.filter.bu !== null ? `
                                <div class="map-overlay__bu">
                                    ${locData.filter.bu.map(item => `
                                        <div class="map-overlay__bu__item">
                                            <div class="map-overlay__bu__item__icon">
                                                <span class="hexagon ${item}">${generateIcon('hexagon-fill', true)}</span>
                                                <span class="bu">${generateIcon(item, true)}</span>
                                            </div>
                                            <div class="map-overlay__bu__item__title">${bu[item]}</div>
                                        </div>
                                    `).join('')}
                                </div>
                            ` : ''}
                        </div>
                        ${locData.image === undefined || null ? '' : `
                        <div class="map-overlay__visual">
                            <img data-src="${locData.image}" class="lazyload map-overlay__visual__image"> 
                        </div>
                        `}
                    </div>
                    <div class="map-overlay__right">
                        ${locData.opening_hours === undefined || null ? '' : `
                            <div class="map-overlay__text text text-small">
                                ${ProjectConfig.get('map.openingHours')}
                                <br>
                                ${formatOpeningHours(locData.opening_hours)}
                            </div>
                        `}
                       
                        ${locData.contact === undefined || null ? '' : `
                            <div class="map-overlay__text text text-small">${locData.contact}</div>
                        `}
                       
                        ${locData.buttons === undefined || null ? '' : `
                            <div class="map-overlay__buttons">
                                ${locData.buttons.map(item => generateButton(item)).join('')}
                            </div>
                        `}
                    </div>
                </div>
            </div>
        `;
    }

    function formatOpeningHours (opening) {
        const openingHours = prepareOpeningHours(opening);

        return `
            ${openingHours.map(line => {
        return `
                ${line.time ? `
                    <div>${line.label} ${line.time}</div>
                ` : ''}
                `;
    }).join('')}
        `;
    }

    function prepareOpeningHours (opening) {
        const dayLabels = ProjectConfig.get('map.dayLabels');
        const formatted = [];
        const masterDays = [];
        const skippedDays = [];

        opening = opening.map((day) => {
            let timeString = '';
            if (day.times) {
                day.times.forEach((timeItem, timeItemIndex) => {
                    if (timeItemIndex > 0) {
                        timeString += ', ';
                    }
                    const splitOpenTime = timeItem.opens_at.split(':');
                    const splitCloseTime = timeItem.closes_at.split(':');
                    timeString += `${splitOpenTime[0]}:${splitOpenTime[1]}` + '–' + `${splitCloseTime[0]}:${splitCloseTime[1]}`;
                });
            }
            day.timeString = timeString;
            return day;
        });

        // mark the master days (first of the group that matches the opening times)
        for (let index = 0; index < opening.length; index++) {
            const day = opening[index];

            if (index < opening.length - 1) {
                const nextDay = opening[index + 1];

                if ((day.timeString === nextDay.timeString && day.times && nextDay.times) || (!day.times && !nextDay.times)) {
                    skippedDays.push(index + 1);
                }
            }
            if (!skippedDays.includes(index)) {
                masterDays.push(index);
            }
        }

        // create rows from master day to the previous day before next master day
        for (let index = 0; index < masterDays.length; index++) {
            const masterDay = masterDays[index];
            let nextMasterDay = masterDays[index + 1];
            if (index >= masterDays.length - 1) {
                nextMasterDay = opening.length;
            }
            const startDayName = dayLabels[masterDay];
            const endDayName = dayLabels[nextMasterDay - 1];

            let label = startDayName;
            if (endDayName !== startDayName && endDayName !== undefined) {
                label += ` ${ProjectConfig.get('map.to')} ` + endDayName;
            }

            let time = opening[masterDay].timeString;
            if (!opening[masterDay].times) {
                time = false;
            }
            const formattedRow = {
                label,
                time,
            };
            formatted.push(formattedRow);
        }
        return formatted;
    }

    init();
}
